import { ServiceBookingModel } from '@xeetr/types/models'

export const EmployeeColumn = (booking: ServiceBookingModel) => booking.employee?.name ?? ''
